import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import Section from "@/components/Section";
import christofferPhoto from "@/assets/christoffer-frisell.jpg";
import henrikPhoto from "@/assets/henrik-bystrom.jpg";

// Member titles intentionally stay in English in both locales.
const teamMembers = [
  {
    id: "christoffer",
    name: "Christoffer Frisell",
    title: "CEO & CO-FOUNDER",
    photo: christofferPhoto,
    imagePosition: "center center",
  },
  {
    id: "henrik",
    name: "Henrik Byström",
    title: "CO-FOUNDER & HEAD OF AI BUSINESS STRATEGY",
    photo: henrikPhoto,
    imagePosition: "center center",
  },
];

const TeamSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      title={t("aboutTeam.title")}
      containerSize="wide"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {teamMembers.map((member) => (
          <Card
            key={member.id}
            className="h-full flex flex-col overflow-hidden border-border/60 bg-card/80 backdrop-blur-sm"
          >
            <CardContent className="p-0 flex flex-col h-full">
              <div className="aspect-[4/3] overflow-hidden bg-muted relative">
                <img
                  src={member.photo}
                  alt={member.name}
                  width="800"
                  height="600"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: member.imagePosition }}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="p-6 space-y-3 flex-grow">
                <h3 className="text-2xl font-bold text-foreground">
                  {member.name}
                </h3>
                <p className="text-sm font-semibold text-gradient-brand uppercase tracking-wide">
                  {member.title}
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  {t(`aboutTeam.members.${member.id}.bio`)}
                </p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </Section>
  );
};

export default TeamSection;
